import { TableColumn } from 'types/types'
import dayjs from 'dayjs'
import { TableActionConfig } from '../../../../components/Table/types'
import { TableActions } from '../../../../components/Table/TableActions'

export const blendsDraftColumns = <T,>(
  actions?: TableActionConfig<T>[]
): TableColumn[] => [
  { id: 'name', label: 'Name', width: 130 },
  { id: 'cost', label: 'Cost', width: 150 },
  {
    id: 'creation_date',
    label: 'Creation Date',
    width: 180,
    format: (value) => dayjs(value).format('DD.MM.YYYY'),
  },
  {
    id: 'created_by_name',
    label: 'Created By',
    width: 180,
  },
  {
    id: 'actions',
    label: '',
    width: '10%',
    align: 'right',
    format: (_, row: T) => <TableActions actions={actions} row={row} />,
  },
]

export const blendsSavedColumns = <T,>(): TableColumn[] => [
  { id: 'name', label: 'Name', width: 100 },
  { id: 'cost', label: 'Cost', width: 150 },
  {
    id: 'created_by_name',
    label: 'Created By',
    width: 180,
  },
  {
    id: 'creation_date',
    label: 'Creation Date',
    width: 120,
    format: (value) => dayjs(value).format('DD.MM.YYYY'),
  },
]
